import { createSlice, type PayloadAction } from "@reduxjs/toolkit"

import type { MeetingProfile } from "@/api/types"
import { logoutAction } from "@/store/session/logoutAction"

interface MeetingProfileCacheEntry {
  meetingProfile: MeetingProfile
  lastUpdated: number
}

interface MeetingProfilesState {
  meetingProfiles: Record<string, MeetingProfileCacheEntry>
}

const initialState: MeetingProfilesState = {
  meetingProfiles: {},
}

const meetingProfilesSlice = createSlice({
  name: "meetingProfiles",
  initialState,
  reducers: {
    setMeetingProfile: {
      reducer(
        state,
        action: PayloadAction<{
          meetingProfile: MeetingProfile
          lastUpdated: number
        }>,
      ) {
        state.meetingProfiles[action.payload.meetingProfile.roomId] =
          action.payload
      },
      prepare(meetingProfile: MeetingProfile) {
        return { payload: { meetingProfile, lastUpdated: Date.now() } }
      },
    },
    removeMeetingProfile(state, action: PayloadAction<string>) {
      delete state.meetingProfiles[action.payload]
    },
    clearMeetingProfiles(state) {
      state.meetingProfiles = {}
    },
  },
  extraReducers: (builder) => {
    builder.addCase(logoutAction, () => initialState)
  },
})

export const { setMeetingProfile, removeMeetingProfile, clearMeetingProfiles } =
  meetingProfilesSlice.actions
export default meetingProfilesSlice.reducer
